import React from "react";
import { Modal } from "bootstrap";
import AppModal from "../common/AppModal";
import DefaultBL from "../../gallery/default/defaultBusinessLogo.png";
import BuyTicket from "../../gallery/icons/buy-ticket.svg";
import { getTicketingUrl, openExternalTicketing } from "../../utils/eventTicketing";

function formatDate(d) {
  const date = new Date(d);
  const dayOfWeek = date.toLocaleString("en-US", { weekday: "long" });
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();
  const day = date.getDate();
  return `${dayOfWeek}, ${day} ${month} ${year}`;
}

function formatTime(d) {
  const date = new Date(d);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
}

export default function HomeExternalEventModal({ event, id = "homePageModal", closeId = "homePageClose" }) {
  if (!event) return null;

  const externalUrl = getTicketingUrl(event);

  const handleBuy = () => {
    openExternalTicketing(event);
    const modalEl = document.getElementById(id);
    if (modalEl) {
      const instance = Modal.getInstance(modalEl);
      if (instance) instance.hide();
    }
  };

  return (
    <AppModal id={id} closeId={closeId}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="col-12 d-flex justify-content-center mb-3">
              {event.image_name && (
                <img className="d-block carousel-img-height img-fluid" alt="..." src={event.image_path || DefaultBL} />
              )}
            </div>
            <h3 className="text-center text-red">{event.name}</h3>
            <h5 className="text-center text-red">
              {event.address1 ? `${event.address1}, ` : ""}
              {event.location || ""}
            </h5>
            <h5 className="text-center text-red">{formatDate(event.start_date)}</h5>
            <h5 className="text-center text-red">{formatTime(event.start_date)} onwards</h5>

            {externalUrl && (
              <button type="button" className="btn btn-event-modal mt-4 w-100" onClick={handleBuy}>
                <img src={BuyTicket} alt="" className="me-3" />
                Buy tickets
              </button>
            )}
          </div>
        </div>
      </div>
    </AppModal>
  );
}
